import { render, staticRenderFns } from "./slides-item.vue?vue&type=template&id=404bc9bd&scoped=true&"
import script from "./slides-item.vue?vue&type=script&lang=js&"
export * from "./slides-item.vue?vue&type=script&lang=js&"
import style0 from "./slides-item.vue?vue&type=style&index=0&id=404bc9bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404bc9bd",
  null
  
)

export default component.exports